import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

import { isBuildTime } from '@powdr/utils';

export const ChatGetskitickets = ({
  botID,
}) => {
  if (isBuildTime()) return null;

  return (
    <Helmet>
      <script
        type="text/javascript"
        id="chatbot-initials-script"
        src="https://bots.getskitickets.com/widget/script-chatbot.js"
        data-server-url="https://bots.getskitickets.com/api"
        data-bot-id={botID}
      />
    </Helmet>
  );
};

ChatGetskitickets.propTypes = {
  botID: PropTypes.string.isRequired,
};
